import axios from "@/plugins/axios.js"

const actions = {
  fetchItems({ commit, state}, payload = {}) {
    return new Promise((resolve, reject) => {
      axios.get(`/notifications?${new URLSearchParams(payload).toString()}`)
        .then((response) => {
          if(response.data.success){
            commit('SET_NOTIFICATIONS', response.data.data)
          }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
  markAsRead({ commit, dispatch }, actId) {
    return new Promise((resolve, reject) => {
      axios.get(`/notifications/${actId}/markasread`)
        .then((response) => {
          dispatch('fetchDashboardData', null, { root: true })
          if(response.data.success){
            commit('MARK_AS_READ', actId)
          }
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}

const getters = {
  // getItem: state => (productId) => state.products.find((product) => product.id == productId),
}

const state = {
  pageData: {
    data: []
  },
}

const mutations = {
  SET_NOTIFICATIONS(state, data) {
    state.pageData = data
  },
  ADD_NOTIFICATION(state, item) {
    state.pageData.data.unshift(item)
  },
  MARK_AS_READ(state, actId){
  	state.pageData.data.map((item)=>{
  		if(item.id == actId){
  			return item.is_read = 1
  		}
  	})
  }

}

export default {
  isRegistered: true,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

